import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import RecordBetsReportUsers from 'views/betShopManagement/reports/betsReport/recordTableTransReport'; // Importing a specific view for user reports
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing the record bets report view.
 * @extends JetView
 */
export default class recordBetsReportView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default size for data fetching from configuration
                },
            ],
        };

        // Left side configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Applying the current theme
                    elements: [
                        {
                            view: 'label', // Label element for displaying text
                            label: _('Historial de Transacciones'), // Translated label text
                            width: 250, // Width of the label
                        },
                    ],
                },
                RecordBetsReportUsers, // Including the imported RecordBetsReportUsers view
                toolbar, // Adding the toolbar to the layout
            ],
        };

        // Returning the main configuration object for the view
        return {
            width: screen !== 'small' ? 500 : 230, // Conditional width based on screen size
            height: screen !== 'small' ? 300 : 230, // Conditional height based on screen size
            type: 'wide', // Type of layout
            cols: [left], // Columns configuration
        };
    }
}

// FILE DOCUMENTED
